import { FormCreateOrUpdateItem } from '@/types/form'
import { createFormData } from '@/utils'
import type { Item } from '@prisma/client'

import axios from '../axios'
import { tryCatch } from '../catch'

export class ItemService {
  static async findAll(productId: number, query?: BaseQuery) {
    try {
      const response = await axios.get<Item[]>(`/products/${productId}/items`, { params: query })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`ItemService.findAll`', error)
    }
  }

  static async findOne(productId: number, id: string) {
    try {
      const response = await axios.get<Item[]>(`/products/${productId}/items/${id}`)
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`ItemService.findOne`', error)
    }
  }

  static async create(productId: number, data: FormCreateOrUpdateItem) {
    try {
      const [formData, headers] = createFormData(data)
      const response = await axios.post<IResponse>(`/products/${productId}/items`, formData, { headers })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`ItemService.create`', error)
    }
  }

  static async update(productId: number, id: string, data: FormCreateOrUpdateItem) {
    try {
      const [formData, headers] = createFormData(data)
      const response = await axios.patch<IResponse>(`/products/${productId}/items/${id}`, formData, {
        headers
      })
      return response.data
    } catch (error) {
      tryCatch('`ItemService.update`', error)
    }
  }

  static async delete(productId: number, id: string) {
    try {
      const response = await axios.delete<IResponse>(`/products/${productId}/items/${id}`)
      return response.data
    } catch (error) {
      tryCatch('`ItemService.delete`', error)
    }
  }
}
